<template lang="pug">
  div()
    .tripStaionery(v-if="trip.lag_time != null")
      svg(xmlns="http://www.w3.org/2000/svg" width="14" height="14")
         circle( cx="7" cy="7" r="5" fill="#ff0000" stroke-width="2" stroke="#ff0000" )
      .caption.ml-2(v-text="getLagTime")
    .newDay(v-if="getNewDay != null" v-html="getNewDay" :style="`background-color:${this.$vuetify.theme.themes.light.primary}`")
    .tripMovement(
      @mouseover="mouseOverTripMovment = true"
      @mouseleave="mouseOverTripMovment = false"
      @click="$emit('selected',index)"
      :style="selected?'background-color:#f5f5f5':(mouseOverTripMovment?'background-color:#EEEEEE':'background-color:#ffffff')"
      )
      svg(xmlns="http://www.w3.org/2000/svg" width="14" height="48")
        path(
            d="M26.06,20.44,32,8.27s-.68-6.78-6.61-6.78-7,6.78-7,6.78l5.94,12.17V31L18.42,43.22S19.1,50,25,50s7-6.78,7-6.78L26.06,31Z"
            transform="translate(-18.42 -1.49)"
            :fill="getColorGrey"
            )
      .tripInfoData()
        .tripPlace(:style="selected?`color:${this.$vuetify.theme.themes.light.primary}`:isPlaceStart?`color:#000000;font-weight:600;`:'color:#666666'" v-html="isPlaceStart?trip.start_location_name.substring(1):trip.start_location_name")
        .tripMiddleRow()
          .d-flex()
            .caption(v-html="getStartTime+getEndTime")
          .tripInfo()
            .span.mr-1(v-if="trip.distance > 0") {{(trip.distance/1000).toFixed(2)}} Kms
            .span(v-text="getTimeSpent")
            //--.span.d-flex.align-center(v-if="trip.efficiency")
                | &nbsp;&nbsp;
                v-icon(color="grey" :size="18" ) local_gas_station
                | &nbsp;{{trip.efficiency.toFixed(2)}} Km/L

        .tripPlace(:style="selected?`color:${this.$vuetify.theme.themes.light.primary}`:isPlaceFinish?`color:#000000;font-weight:600;`:'color:#666666'" v-html="isPlaceFinish?trip.end_location_name.substring(1):trip.end_location_name")

</template>
<script>
import moment from "moment";


export default {
  props: {
    trip: Object,
    selected: {
      type: Boolean,
      default: false
    },
    index: Number
  },
  data: () => ({
    mouseOverTripMovment: false
  }),


  computed: {
    getNewDay:function(){
      if(this.index==0 || (moment(this.trip.max_time)
              .format("DD")
              .toString() !=
          moment(
              this.$store.state.trips.trip_data[this.index - 1].max_time
          ).format("DD"))){
        if(this.trip.max_time.toString()=="0001-01-01T00:00:00Z"){
          return moment(this.trip.min_time).format("dddd, Do MMMM YYYY")
        }else{
          return moment(this.trip.max_time).format("dddd, Do MMMM YYYY")
        }

      }else{
        return null;
      }
    },

    getContainerStyle: function(){
        let obj = {};
      console.log(this.index)
      if(this.index == 0 || moment(this.trip.max_time)
              .format("DD")
              .toString() !=
          moment(
              this.$store.state.trips.trip_data[this.index - 1].max_time
          ).format("DD")){
        obj['border-bottom'] = `2px solid ${this.$vuetify.theme.themes.light.primary}`
      }
        return obj;
    },
    isPlaceStart:function(){
      if (this.trip.start_location_name.length <= 1) return false;
      return this.trip.start_location_name[0]==='%'
    },

    isPlaceFinish:function(){
      if (this.trip.end_location_name.length <= 1) return false;
      return this.trip.end_location_name[0]==='%'
    },

    getStartTime() {
      //1:59 PM - 28 Apr
      return moment(this.trip.min_time).format("h:mm a");
    },

    getEndTime() {
      return " &ndash;" + moment(this.trip.max_time).format("h:mm a");
    },

    getEndDate() {
      // return the first trip date
      if (this.index == 0) {
        return " &mdash;" + moment(this.trip.max_time).format("ddd, Do MMM");
      }

      let tempValue = "";
      // compare with previous maxtime to check if the dates are the same
      if (
        moment(this.trip.max_time)
          .format("DD")
          .toString() !=
        moment(
          this.$store.state.trips.trip_data[this.index - 1].max_time
        ).format("DD")
      ) {
        tempValue =
          " &mdash; " + moment(this.trip.max_time).format("ddd, Do MMM");
      }

      return tempValue;
    },

    getStartDate() {
      return moment(this.trip.min_time).format("D MMM");
    },

    getTimeSpent() {
      let microseconds = moment
        .utc(
          moment
            .duration(this.trip.timespent.Microseconds / 1000000, "seconds")
            .asMilliseconds()
        )


      let days =
        this.trip.timespent.Days > 0
          ? this.trip.timespent.Days + " Days + "
          : "";

      let months =
        this.trip.timespent.Months > 0
          ? this.trip.timespent.Months + " Months + "
          : "";

      let hours = microseconds.hours() > 0 ? " "+microseconds.hours()+"h" : ""
      let minutes = microseconds.minutes() > 0 || microseconds.hours() > 0 ? " " + microseconds.minute()+ "m":"";
      let seconds = microseconds.seconds() > 0 || microseconds.minutes() >0 || microseconds.hour() > 0 ? " " + microseconds.seconds()+"s":"";

      return " | " +months + days + hours + minutes + seconds;
    },

    // get duration and convert to tune tajeb
    getLagTime() {
      let microseconds = moment
        .utc(
          moment
            .duration(this.trip.lag_time.Microseconds / 1000000, "seconds")
            .asMilliseconds()
        )


      let days =
        this.trip.lag_time.Days > 0 ? this.trip.lag_time.Days + " Days + " : "";

      let months =
        this.trip.lag_time.Months > 0
          ? this.trip.lag_time.Months + " Months + "
          : "";


      let hours = microseconds.hours() > 0 ? " "+microseconds.hours()+"h" : ""
      let minutes = microseconds.minutes() > 0 || microseconds.hours() > 0 ? " " + microseconds.minute()+ "m":"";
      let seconds = microseconds.seconds() > 0 ? " " + microseconds.seconds()+"s":"";

      return months + days + hours + minutes + seconds;
    },
    getColorGrey() {
      return this.selected
        ? this.$vuetify.theme.themes.light.primary
        : this.mouseOverTripMovment
        ? this.$vuetify.theme.themes.light.primary
        : "#BDBDBD";
    }
  },

  methods: {
    millisToMinutesAndSeconds: function(millis) {
      millis = millis / 1000;
      var minutes = Math.floor(millis / 60000);
      var seconds = ((millis % 60000) / 1000).toFixed(0);
      return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
    },


  }
};
</script>
<style scoped lang="stylus">
.tripMovement {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background-color: #ffffff;
  cursor: pointer;
}

.tripStaionery {
  display: flex;
  padding: 8px 12px;
  align-items: center;
}

.tripStaionerHover {
  background-color: #f5f5f5;
}

.tripPlace {
  font-size: 12px;
  white-space: nowrap;
  font-weight:500;
}

.tripInfo {
  font-size: 12px;
  margin: -2px 0;
  flex-wrap: wrap;
  display: flex;
}

.tripMiddleRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.tripInfoData {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px 10px;
}

.newDay{
  color:#FFFFFF;

  display: flex;
  align-items: center;
  padding:5px 10px;
  font-size: 13px;
  font-weight: bold;


}
</style>
